module.exports = __webpack_public_path__ + "img/05.c3fb4051.png";